import React from "react"

import { GetSingleUser } from "services/user/type"

import { ReactComponent as PencilIcon } from "../../../assets/icons/pencil.svg"

export interface UserInfoPersonalCardProps {
  user: GetSingleUser
  setOpenEditUser: (value: boolean) => void
}

export const UserInfoPersonalCard = ({ user, setOpenEditUser }: UserInfoPersonalCardProps) => {
  return (
    <div className="flex flex-col gap-2 p-6 w-full rounded-[8px] border border-[rgba(0,0,0,0.1)] dark:border-transparent bg-[rgba(212,212,212,0.1)] dark:bg-[rgba(255,255,255,0.04)] text-white backdrop-blur-md">
      <div className="flex flex-row gap-4 text-black dark:text-white text-lg mb-4">
        Personal Information
        <button className="flex items-center justify-center h-full text-black dark:text-white " onClick={() => setOpenEditUser(true)}>
          <PencilIcon className="w-5 h-5 hover:text-[rgba(188,43,228,0.8)] transition-all" />
        </button>
      </div>
      <div className="flex flex-col gap-3">
        <div className="flex justify-between gap-3">
          <div className="text-base text-black dark:text-[rgba(156,163,175,1)] text-nowrap">First Name</div>
          <div className="text-base text-black dark:text-white">{user.personal_profile.first_name}</div>
        </div>
        <div className="flex justify-between gap-3">
          <div className="text-base text-black dark:text-[rgba(156,163,175,1)]">Last Name</div>
          <div className="text-base text-black dark:text-white">{user.personal_profile.last_name}</div>
        </div>
        <div className="flex justify-between gap-3">
          <div className="text-base text-black dark:text-[rgba(156,163,175,1)]">Date of Birth</div>
          <div className="text-base text-black dark:text-white">{user.personal_profile.dob}</div>
        </div>
        <div className="flex justify-between gap-3">
          <div className="text-base text-black dark:text-[rgba(156,163,175,1)]">Country</div>
          <div className="text-base text-black dark:text-white">{user.personal_profile.country}</div>
        </div>
        <div className="flex justify-between gap-3">
          <div className="text-base text-black dark:text-[rgba(156,163,175,1)]">City</div>
          <div className="text-base text-black dark:text-white">{user.personal_profile.city}</div>
        </div>
        <div className="flex justify-between gap-3">
          <div className="text-base text-black dark:text-[rgba(156,163,175,1)]">Address</div>
          <div className="text-base text-black dark:text-white">
            {user.personal_profile.address} {user.personal_profile.address2}
          </div>
        </div>
        <div className="flex justify-between gap-3">
          <div className="text-base text-black dark:text-[rgba(156,163,175,1)]">Zip Code</div>
          <div className="text-base text-black dark:text-white">{user.personal_profile.zip}</div>
        </div>
      </div>
    </div>
  )
}
